'use client';

import { cn } from '~/lib/utils';

type DrawerBodyProps = {
  children: React.ReactNode;
  className?: string;
};

export default function DrawerBody({ children, className }: DrawerBodyProps) {
  return (
    <div className={cn('min-h-0 flex-1 overflow-y-auto px-5 pt-5 pb-6', className)}>{children}</div>
  );
}
